import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useUser } from '~/composables/_next/useUser';
export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyCart',
  props: {
    dyContext: null
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar,
      handleLoginNavigation = _useUiState.handleLoginNavigation,
      closeCartSidebar = _useUiState.closeCartSidebar;
    var _useDynamicYield = useDynamicYield(),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext;

    /**
     * Closes the empty cart and restores Dynamic Yield context.
     */
    function closeEmptyCart() {
      return _closeEmptyCart.apply(this, arguments);
    }
    function _closeEmptyCart() {
      _closeEmptyCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props$dyContext, _props$dyContext2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setDynamicYieldContext((_props$dyContext = props.dyContext) === null || _props$dyContext === void 0 ? void 0 : _props$dyContext.type, (_props$dyContext2 = props.dyContext) === null || _props$dyContext2 === void 0 ? void 0 : _props$dyContext2.data);
            case 2:
              closeCartSidebar();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _closeEmptyCart.apply(this, arguments);
    }
    return {
      __sfc: true,
      route: route,
      isAuthenticated: isAuthenticated,
      toggleCartSidebar: toggleCartSidebar,
      handleLoginNavigation: handleLoginNavigation,
      closeCartSidebar: closeCartSidebar,
      setDynamicYieldContext: setDynamicYieldContext,
      props: props,
      closeEmptyCart: closeEmptyCart,
      AzIcon: AzIcon,
      AzButton: AzButton
    };
  }
});